var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFiRsGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8343_103699)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 7H17.866C18.5591 6.36808 19.1083 5.59461 19.4765 4.73197C19.8447 3.86932 20.0232 2.93764 20 2H18C18 4.881 16.029 6.307 13.848 6.8C14.5029 5.6318 14.896 4.33519 15 3C15 2.20435 14.6839 1.44129 14.1213 0.87868C13.5587 0.31607 12.7956 0 12 0C11.2044 0 10.4413 0.31607 9.87868 0.87868C9.31607 1.44129 9 2.20435 9 3C9.10405 4.33519 9.49712 5.6318 10.152 6.8C7.971 6.307 6 4.881 6 2H4C3.97679 2.93764 4.15532 3.86932 4.5235 4.73197C4.89167 5.59461 5.4409 6.36808 6.134 7H3C2.20435 7 1.44129 7.31607 0.87868 7.87868C0.31607 8.44129 0 9.20435 0 10L0 14H2V24H22V14H24V10C24 9.20435 23.6839 8.44129 23.1213 7.87868C22.5587 7.31607 21.7956 7 21 7ZM12 2C12.2652 2 12.5196 2.10536 12.7071 2.29289C12.8946 2.48043 13 2.73478 13 3C12.8793 4.06283 12.5387 5.08891 12 6.013C11.4613 5.08891 11.1207 4.06283 11 3C11 2.73478 11.1054 2.48043 11.2929 2.29289C11.4804 2.10536 11.7348 2 12 2ZM2 10C2 9.73478 2.10536 9.48043 2.29289 9.29289C2.48043 9.10536 2.73478 9 3 9H11V12H2V10ZM4 14H11V22H4V14ZM20 22H13V14H20V22ZM22 12H13V9H21C21.2652 9 21.5196 9.10536 21.7071 9.29289C21.8946 9.48043 22 9.73478 22 10V12Z",
    fill: "#1D1D1D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8343_103699"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiRsGift);
export default __webpack_public_path__ + "static/media/fi-rs-gift.8b8dca3a3d5ce0852a0e64ee4883699e.svg";
export { ForwardRef as ReactComponent };